import store from '../store'
import { setIsPopoverChatOpen } from '../store/general/actions'
import { addPopoverNotificationMessage } from '../store/maya/actions'

// FUNCTION OUR CLIENTS CAN USE TO OPEN THE MAYA POPOVER CHAT
export const openMayaPopoverChat = (state = true) => {
  // EXAMPLE USAGE: window.openMayaPopoverChat(true)
  store.dispatch(setIsPopoverChatOpen(state))
}

// FUNCTION OUR CLIENTS CAN USE TO ADD A POPOVER NOTIFICATION MESSAGE
export const addMayaPopoverNotification = message => {
  // EXAMPLE USAGE: window.addMayaPopoverNotification('This is a test notification')
  store.dispatch(addPopoverNotificationMessage(message))
}
